export const DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_WIDTH = 200

export const DOC_FLOW_MAPPING_FILE_LIST_SLIDER_ITEM_GAP = 16
